import { ActionItem, ChangeGroup, WatchdogHealth } from './types';

// Session-lived caches so navigating back to a page paints instantly with the
// last known data while a background refresh runs (stale-while-revalidate).
// Cleared only by a full page reload.

export const listCache: {
  items: ActionItem[] | null;
  health: WatchdogHealth | null | undefined;
  recovered: ActionItem[];
  /** Search, My campaigns and the Closed section's fold, kept across card round trips (Esc must not reset a filter). */
  view: { q: string; myActive: boolean; closedOpen: boolean } | null;
} = { items: null, health: undefined, recovered: [], view: null };

/** Per-item seed so the detail view renders without waiting on its fetch. */
export const itemCache = new Map<string, ActionItem>();

/** Change Log default view (first page, no filters) — the back-navigation case. */
export const changeLogCache: { rows: ChangeGroup[] | null } = { rows: null };
